import { Email, Facebook, Telegram, Twitter, WhatsApp } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";
import {
    EmailShareButton,
    FacebookShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,

} from "react-share";



const Sharemini = ({ link, name }) => {
    const iconstyle = {
        height: 40,
        width: 40
    }

    return (
        <div style={{ display: "flex" }}>
            <FacebookShareButton url={link}
                quote={name}
                hashtag={name}>
                <IconButton>
                    <Facebook />
                </IconButton>
            </FacebookShareButton>&nbsp;
            <WhatsappShareButton url={link}
                quote={name}
                hashtag={name}>
                <IconButton>
                    <WhatsApp />
                </IconButton>
            </WhatsappShareButton>&nbsp;
            <TwitterShareButton url={link}
                quote={name}
                hashtag={name}>
                <IconButton>
                    <Twitter />
                </IconButton>
            </TwitterShareButton>&nbsp;
            <TelegramShareButton url={link}
                quote={name}
                hashtag={name}>
                <IconButton>
                    <Telegram />
                </IconButton>
            </TelegramShareButton>&nbsp;
            <EmailShareButton url={link}
                quote={name}
                hashtag={name}>
                <IconButton>
                    <Email />
                </IconButton>
            </EmailShareButton>
        </div>
    )
}

export default Sharemini;